module.exports = __webpack_public_path__ + "static/media/policy-icon.e8527300.svg";